<div class="ds-select">
  <span class="ds-select-chevron"><app-ds-icon name="ChevronDown"></app-ds-icon></span>
  <select (change)="onSelectChange($event)" [ngClass]="{'default': this.value === ''}">
    <option value="">{{placeholder}}</option>
    <ng-container *ngFor="let option of options">
      <option [value]="option.value">{{option.caption}}</option>
    </ng-container>
  </select>
</div>
